module.exports = __webpack_public_path__ + "images/whatsapp_bg6b26315d859fd5c94f2c4667ee01c3a7.png";